import { useAuthStore } from '../../stores/authStore';

const KEYCLOAK_URL = import.meta.env.VITE_KEYCLOAK_URL || 'https://qavok.io/auth';
const REALM = import.meta.env.VITE_KEYCLOAK_REALM || 'qavok';
const CLIENT_ID = import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'qavok-frontend';
const TOKEN_URL = `${KEYCLOAK_URL}/realms/${REALM}/protocol/openid-connect/token`;
const REFRESH_INTERVAL = 4 * 60 * 1000; // 4 minutes

let refreshTimer: ReturnType<typeof setInterval> | null = null;

export function startTokenRefresh(): void {
  stopTokenRefresh();

  refreshTimer = setInterval(async () => {
    const { refreshToken, logout } = useAuthStore.getState();
    if (!refreshToken) {
      stopTokenRefresh();
      logout();
      return;
    }

    try {
      const resp = await fetch(TOKEN_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({
          grant_type: 'refresh_token',
          client_id: CLIENT_ID,
          refresh_token: refreshToken,
        }),
      });

      const data = await resp.json();
      if (data.access_token) {
        useAuthStore.getState().setFromToken(data.access_token, data.refresh_token);
      } else {
        logout();
        window.location.href = '/login';
      }
    } catch {
      // Silent fail — will retry next interval
    }
  }, REFRESH_INTERVAL);
}

export function stopTokenRefresh(): void {
  if (refreshTimer) {
    clearInterval(refreshTimer);
    refreshTimer = null;
  }
}
